import React, { useEffect, useState } from 'react';
import useSWR from 'swr';

import { getProjectPages } from '../utils/woorankApi';
import { useI18n } from '@hydra/common/customHooks';
import {
  Card,
  DataTable,
  Link,
  SkeletonBodyText,
  SkeletonThumbnail,
  TextStyle
} from '@shopify/polaris';
import { getRelativeDate } from '@hydra/utils/formatDate';
import ScoreCircle from '@hydra/common/components/ScoreCircle';
import { shopifyRelativeUrl } from '../utils/url';

interface InternalPageViewProps {
  host: string;
  apiKey: string;
}

export default function InternalPageView ({
  host,
  apiKey
}: InternalPageViewProps) {
  const { translate, moment } = useI18n();
  const [reports, setReports] = useState([]);
  const [isLoading, isLoadingSet] = useState(true);
  const { data: reviewList, error } = useSWR(
    apiKey ? `/woorank-api/review-page/${host}` : null,
    () => getProjectPages(host, apiKey, 10)
  );

  useEffect(() => {
    if (reviewList) {
      setReports(reviewList.reports);
      isLoadingSet(false);
    }
  }, [reviewList]);

  const rows = reports.map((review: any) => [
    <ScoreCircle
      key={`score_${review.url}`}
      score={review.score}
      size='small'
    />,
    <Link
      monochrome
      removeUnderline
      key={`review_link_${review.url}`}
      url={shopifyRelativeUrl(`/shopify/review-display/${encodeURIComponent(review.url)}`, window.location)}
    >
      <TextStyle variation='strong'>
        {review.url}
      </TextStyle>
    </Link>,
    getRelativeDate({ date: new Date(review.createdAt), moment })
  ]);

  const emptyRows = Array.from(Array(5).keys()).map((index) => [
    <SkeletonThumbnail key={index} size='small' />,
    <SkeletonBodyText key={index} lines={1} />,
    <SkeletonBodyText key={index} lines={1} />
  ]);

  return (
    <Card>
      <DataTable
        increasedTableDensity
        verticalAlign='middle'
        columnContentTypes={['text', 'text', 'text', 'text']}
        headings={[
          translate('table_head_score'),
          translate('table_head_url'),
          translate('table_head_created_on')
        ]}
        rows={isLoading ? emptyRows : rows}
      />
    </Card>
  );
}
